import Styles from "../../../scss/discounts.module.scss";

export function DiscountNoOfUses({
  max,
  NoOfUses,
  key,
}: {
  max: number;
  NoOfUses: number;
  key: any;
}) {
  return (
    <span className={Styles.DiscountNoOfUsesContainer} key={key}>
      {max === 0 ? (
        <span>0</span>
      ) : (
        <span>
          <strong>{NoOfUses ? NoOfUses : 0}</strong>
          {max && `/${max}`}
        </span>
      )}
    </span>
  );
}
